import { useMsal } from '@azure/msal-react'
import { Menu } from '@headlessui/react'
import { GlobeAltIcon, UserIcon } from '@heroicons/react/24/outline'
import { NavigationBar, NotificationsMenuItem, SistemivLogoIcon } from '@sistemiv/s-components'
import React, { FC } from 'react'
import { useNavigate } from 'react-router'
import { useUser } from '../../repositories/users/user.repository'
import { loginRequest } from '../../services/AuthConfig'

const TopNav: FC = () => {
  const navigate = useNavigate()
  const { instance } = useMsal()

  // const [user, setUser] = useState<UserProfile | null>(null)

  const { data: user } = useUser({ userId: instance.getActiveAccount()?.localAccountId })

  const handleLogout = async () => {
    instance
      .acquireTokenSilent({ ...loginRequest, account: instance.getActiveAccount() ?? undefined })
      .then(({ idToken }) => {
        instance.logoutRedirect({
          account: instance.getActiveAccount(),
          idTokenHint: idToken,
        })
      })
  }

  // useEffect(() => {
  //   const accounts = instance.getAllAccounts()
  //   if (accounts[0]) {
  //     UserService.get(accounts[0].localAccountId).then(setUser)
  //   }
  // }, [instance])

  return (
    <NavigationBar className='h-[4.185rem] border-b border-gray-300 flex items-center justify-between'>
      <div className='flex items-center gap-x-2 cursor-pointer' onClick={() => navigate('/')}>
        <SistemivLogoIcon className='text-[#2dcbfb] w-[40px] h-[30px]' />
        <p className='text-[#4b4f57] font-bold'>MY PROFILE</p>
      </div>
      <div className='flex items-center gap-x-3'>
        <NotificationsMenuItem
          unreadNotifications={3}
          labels={{
            notifications: 'Notifications',
            show_unread: 'Show unread',
            mark_all_as_read: 'Mark all as read',
          }}
        />
        <Menu as='div' className='relative'>
          <Menu.Button
            name='nav-language'
            className='inline-flex w-full justify-center items-center gap-x-2 px-3 py-2 rounded-md hover:bg-sky-50 active:bg-sky-100'
          >
            <GlobeAltIcon className='h-5 w-5' />
            <div>English</div>
          </Menu.Button>
          <Menu.Items className='absolute right-2 z-10 mt-2 w-56 origin-top-right flex flex-col bg-white py-3 drop-shadow'>
            <Menu.Item>
              <div
                className='py-2 px-4 cursor-pointer w-full hover:bg-sky-50 active:bg-sky-100'
                data-testid='nav-language'
              >
                Srpski
              </div>
            </Menu.Item>
          </Menu.Items>
        </Menu>
        <Menu as='div' className='relative'>
          <Menu.Button className='flex items-center justify-center'>
            <div className='bg-[#7b87ae] w-8 h-8 rounded-full overflow-hidden text-white flex items-center justify-center text-lg leading-[18px]'>
              {user?.data.photo ? (
                <img src={user.data.photo} className='w-full h-full' />
              ) : (
                <p className='font-bold text-md'>
                  {user ? user.data?.firstName?.charAt(0) : <UserIcon className='w-full h-full text-white' />}
                </p>
              )}
            </div>
          </Menu.Button>
          <Menu.Items className='absolute right-2 z-10 mt-2 w-56 origin-top-right flex flex-col bg-white py-3 drop-shadow'>
            <Menu.Item as='div' onClick={() => handleLogout()}>
              <div className='py-2 px-4 cursor-pointer w-full hover:bg-sky-50 active:bg-sky-100'>Logout</div>
            </Menu.Item>
          </Menu.Items>
        </Menu>
      </div>
    </NavigationBar>
  )
}

export default TopNav
